import { IRequest } from "../../../model/request/Request";
import { DateService } from "../../../service/DateService";

export interface TRequestPresentationModel {
  id: number;
  reportingPeriodApplicantId: number;
  requestTypeCode: string;
  name: string;
  content?: string;
  priority: number;
  read: boolean;
  valid: boolean;
  validFrom: string;
  validTo?: string;
}

const RequestPresentationModel = (
  data: IRequest
): TRequestPresentationModel => {
  const validFrom = DateService().formatDate(data.validFrom);
  const validTo = data.validTo
    ? DateService().formatDate(data.validTo)
    : undefined;
  return {
    id: data.id,
    reportingPeriodApplicantId: data.reportingPeriodApplicantId,
    requestTypeCode: data.requestTypeCode,
    name: data.name,
    content: data.content,
    priority: data.priority,
    read: data.read,
    valid: data.valid,
    validFrom,
    validTo
  };
};

export default RequestPresentationModel;
